import {Injectable} from '@angular/core';
import {PromptDialogService, MydocmaPromptButtonTypeEnum} from '@mydocma/component-library/src/lib/prompt-dialog';
import {TranslateService} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class AnnotationViewService {

  constructor(
    private readonly promptDialogService: PromptDialogService,
    private readonly translateService: TranslateService
  ) {}

  public async showFatClientWarning(): Promise<void> {
    await this.promptDialogService.showPromptDialog({
      title: await this.translateService.get('MM.annotations.fatClientWarning.title').toPromise(),
      content: await this.translateService.get('MM.annotations.fatClientWarning.content').toPromise(),
      buttons: [
        {
          text: 'Ok',
          type: MydocmaPromptButtonTypeEnum.primary,
          value: true
        }
      ]
    });
  }
}
